module.exports.BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
module.exports.MOCK_BACKEND_URL = process.env.REACT_APP_MOCK_BACKEND_URL || "";
module.exports.FRONT_URL = process.env.REACT_APP_FRONT_URL || "";
module.exports.AMO_COMPLETED_ID = 142;
module.exports.AMO_ABORTED_ID = 143;
